import React from 'react';
import { PauseCircleOutlineRounded } from '@mui/icons-material';

import { ReactComponent as TeamMenuSvg } from 'assets/images/menu_team.svg';
import { ReactComponent as BuildingMenuSvg } from 'assets/images/menu_building.svg';
import { ReactComponent as DashboardMenuSvg } from 'assets/images/menu_dashboard.svg';
import { ReactComponent as EmployeesMenuSvg } from 'assets/images/menu_employees.svg';
import { ReactComponent as FeedbackMenuSvg } from 'assets/images/menu_feedback.svg';
import { ReactComponent as ReportingMenuSvg } from 'assets/images/menu_reporting.svg';
import { ReactComponent as ZonesMenuSvg } from 'assets/images/menu_zones.svg';
import { ROUTES } from 'consts';
import { EUserRole } from 'enums';
import { INavItem } from 'models';
import { theme } from './theme.config';

export const desktopHeaderMenuConfig: Array<INavItem> = [
  {
    id: 'how-it-works',
    label: 'How it Works',
    link: 'https://www.cleancode.us/#how-it-works',
    roles: [],
    style: {
      color: `${theme.palette.text.primary} !important`,
    },
  },
  {
    id: 'view-the-featuress',
    label: 'View the Features',
    link: 'https://www.cleancode.us/#view-features',
    roles: [],
    style: {
      color: `${theme.palette.text.primary} !important`,
    },
  },
  {
    id: 'contact-us',
    label: 'Contact Us',
    link: 'https://www.cleancode.us/connect',
    roles: [],
    style: {
      color: `${theme.palette.text.primary} !important`,
    },
  },
  {
    id: 'login',
    label: 'Log in',
    link: `/${ROUTES.AUTH}/${ROUTES.AUTH_LOGIN}`,
    variant: 'contained',
    roles: [],
  },
];

export const unauthMobileHeaderMenuConfig: Array<INavItem> = [
  {
    id: 'home',
    label: 'Home',
    link: 'https://www.cleancode.us',
    roles: [],
    style: {
      color: `${theme.palette.text.primary} !important`,
    },
  },
  {
    id: 'how-it-works',
    label: 'How it Works',
    link: 'https://www.cleancode.us/#how-it-works',
    roles: [],
    style: {
      color: `${theme.palette.text.primary} !important`,
    },
  },
  {
    id: 'view-the-featuress',
    label: 'View the Features',
    link: 'https://www.cleancode.us/#view-features',
    roles: [],
    style: {
      color: `${theme.palette.text.primary} !important`,
    },
  },
  {
    id: 'contact-us',
    label: 'Contact us',
    link: 'https://www.cleancode.us/connect',
    roles: [],
    style: {
      color: `${theme.palette.text.primary} !important`,
    },
  },
  {
    id: 'login',
    label: 'Log in',
    link: ROUTES.AUTH_LOGIN,
    roles: [],
    style: {
      color: `${theme.palette.primary.contrastText} !important`,
      backgroundColor: `${theme.palette.primary.main} !important`,
    },
  },
];

export const authMobileSidebarMenuConfig: Array<INavItem> = [
  {
    id: 'dashboard',
    icon: <DashboardMenuSvg />,
    label: 'Dashboard',
    link: ROUTES.DASHBOARD,
    roles: [],
  },
  {
    id: 'buildings',
    icon: <BuildingMenuSvg />,
    label: 'Buildings',
    link: ROUTES.BUILDINGS,
    roles: [],
  },
  {
    id: 'zones',
    icon: <ZonesMenuSvg />,
    label: 'Zones',
    link: ROUTES.ZONES,
    roles: [EUserRole.BASIC, EUserRole.ADMIN],
  },
  {
    id: 'interruptions',
    icon: <PauseCircleOutlineRounded />,
    label: 'Interruptions',
    link: ROUTES.SERVICE_INTERRUPTIONS,
    roles: [EUserRole.ADMIN],
  },
  {
    id: 'feedback',
    icon: <FeedbackMenuSvg />,
    label: 'Feedback',
    link: ROUTES.FEEDBACK,
    roles: [],
  },
  {
    id: 'reporting',
    icon: <ReportingMenuSvg />,
    label: 'Reporting',
    link: ROUTES.REPORTS,
    roles: [],
  },
  {
    id: 'team',
    icon: <TeamMenuSvg />,
    label: 'Team',
    link: ROUTES.TEAM,
    roles: [],
  },
  {
    id: 'employees',
    icon: <EmployeesMenuSvg />,
    label: 'Employees',
    link: ROUTES.EMPLOYEES,
    roles: [],
  },
];

export const profileMobileSidebarMenuConfig = (orgSlug: string): Array<INavItem> => [
  {
    id: 'user-settings',
    label: 'User Settings',
    link: `/${orgSlug}/${ROUTES.PROFILE}/${ROUTES.PROFILE_USER_SETTINGS}`,
    roles: [],
  },
  {
    id: 'company-settings',
    label: 'Company Settings',
    link: `/${orgSlug}/${ROUTES.PROFILE}/${ROUTES.COMPANY_SETTINGS}`,
    roles: [],
  },
  {
    id: 'zone-categories',
    label: 'Zone Categories',
    link: `/${orgSlug}/${ROUTES.PROFILE}/${ROUTES.ZONE_CATEGORIES}`,
    roles: [],
  },
  {
    id: 'password',
    label: 'Password',
    link: `/${orgSlug}/${ROUTES.PROFILE}/${ROUTES.PROFILE_PASSWORD}`,
    roles: [],
  },
  {
    id: 'invite-users',
    label: 'Invite Users',
    link: `/${orgSlug}/${ROUTES.PROFILE}/${ROUTES.PROFILE_INVITE_USERS}`,
    roles: [EUserRole.ADMIN],
  },
  {
    id: 'order-decals',
    label: 'Order Decals',
    link: `/${orgSlug}/${ROUTES.ORDER_DECALS}`,
    roles: [EUserRole.ADMIN],
  },
  {
    id: 'billing',
    label: 'Billing',
    link: `/${orgSlug}/${ROUTES.PROFILE}/${ROUTES.PROFILE_BILLING}`,
    roles: [EUserRole.ADMIN],
  },
];

export const dashboardSidebarMenuConfig = [
  {
    id: 'dashboard',
    icon: <DashboardMenuSvg />,
    label: 'Dashboard',
    link: ROUTES.DASHBOARD,
    roles: [EUserRole.BASIC, EUserRole.ADMIN],
  },
  {
    id: 'buildings',
    icon: <BuildingMenuSvg />,
    label: 'Buildings',
    link: ROUTES.BUILDINGS,
    roles: [EUserRole.BASIC, EUserRole.ADMIN],
  },
  {
    id: 'zones',
    icon: <ZonesMenuSvg />,
    label: 'Zones',
    link: ROUTES.ZONES,
    roles: [EUserRole.BASIC, EUserRole.ADMIN],
  },
  {
    id: 'interruptions',
    icon: <PauseCircleOutlineRounded />,
    label: 'Interruptions',
    link: ROUTES.SERVICE_INTERRUPTIONS,
    roles: [EUserRole.ADMIN],
  },
  {
    id: 'feedback',
    icon: <FeedbackMenuSvg />,
    label: 'Feedback',
    link: ROUTES.FEEDBACK,
    roles: [EUserRole.BASIC, EUserRole.ADMIN],
  },
  {
    id: 'reporting',
    icon: <ReportingMenuSvg />,
    label: 'Reporting',
    link: ROUTES.REPORTS,
    roles: [EUserRole.BASIC, EUserRole.ADMIN],
  },
  {
    id: 'team',
    icon: <TeamMenuSvg />,
    label: 'Team',
    link: ROUTES.TEAM,
    roles: [EUserRole.ADMIN],
  },
  {
    id: 'employees',
    icon: <EmployeesMenuSvg />,
    label: 'Employees',
    link: ROUTES.EMPLOYEES,
    roles: [EUserRole.ADMIN],
  },
];
